import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "05010f98-1625-496a-859f-8d4933433706",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "7e821abc-d372-445a-97b7-718c735ea6f1",
      type: "Container",
      name: "sideContainer",
      nameSpace: "",
      className: "",
      x: 300,
      y: -248,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "05010f98-1625-496a-859f-8d4933433706",
      data: ""
    },
    {
      id: "5cc0e50b-3468-459b-9786-5a36aeecfa5f",
      type: "Sprite",
      name: "bg",
      nameSpace: "",
      className: "",
      x: 0,
      y: 35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_background_2",
      parent: "05010f98-1625-496a-859f-8d4933433706",
      data: ""
    },
    {
      id: "da99047f-7c99-48ff-8fbd-f5e8356f539e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 92,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_underlay",
      parent: "05010f98-1625-496a-859f-8d4933433706",
      data: ""
    },
    {
      id: "0d02c613-ef36-4e94-86a4-e7245b6090dc",
      type: "Sprite",
      name: "headerBg",
      nameSpace: "",
      className: "",
      x: -4,
      y: -266,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "header_blank",
      parent: "05010f98-1625-496a-859f-8d4933433706",
      data: ""
    },
    {
      id: "6b8770b9-2782-4329-8551-7b5c5ee148f9",
      type: "Text",
      name: "levelText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -261,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Level 11 Complete!",
      localize: false,
      maxWidth: 524,
      maxHeight: 121,
      maxFontSize: 49,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#933019",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#b83500",
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "05010f98-1625-496a-859f-8d4933433706",
      data: ""
    },
    {
      id: "1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2",
      type: "Container",
      name: "starsContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "05010f98-1625-496a-859f-8d4933433706",
      data: ""
    },
    {
      id: "3b9dbbb0-b7f5-4938-89c7-e9582233102a",
      type: "Sprite",
      name: "closeButton",
      nameSpace: "",
      className: "",
      x: 361,
      y: -252,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "btn_close",
      parent: "05010f98-1625-496a-859f-8d4933433706",
      data: ""
    },
    {
      id: "15be72c1-a4a7-421a-94d4-3e4c908b941a",
      type: "Sprite",
      name: "character",
      nameSpace: "",
      className: "",
      x: -458,
      y: 380,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "character_happy_1",
      parent: "05010f98-1625-496a-859f-8d4933433706",
      data: ""
    },
    {
      id: "6635b2ef-0304-4c20-bb80-a1e9f6eea59f",
      type: "Sprite",
      name: "playContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blank",
      parent: "05010f98-1625-496a-859f-8d4933433706",
      data: ""
    },
    {
      id: "280699fb-d598-46e8-9ddd-c56b604573e7",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "05010f98-1625-496a-859f-8d4933433706",
      data: ""
    },
    {
      id: "af8a396e-d56d-41d7-adf0-8452dbcf8896",
      type: "Graphics",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 142,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "05010f98-1625-496a-859f-8d4933433706",
      bake: false,
      commands: [
        {
          id: "c12954da-62d6-4c61-b78c-2c0cc533a8d4",
          type: "lineStyle",
          width: 1,
          color: 14658178,
          alpha: 1,
          alignment: 0.5,
          native: false
        },
        {
          id: "4e16380a-c5e6-436a-a37b-7e30e948ec20",
          type: "drawRect",
          x: -260,
          y: 0,
          width: 520,
          height: 2
        }
      ],
      data: ""
    },
    {
      id: "c3386ccf-bf90-454f-b268-16e051e0ca43",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "starPlaces",
      x: -198,
      y: -56,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -10,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "big_star_place",
      parent: "1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2",
      data: ""
    },
    {
      id: "bc297106-f680-4705-a3f0-f7f17c531df3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "starPlaces",
      x: 0,
      y: -68,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "big_star_place",
      parent: "1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2",
      data: ""
    },
    {
      id: "6e0ca20e-0841-41ba-9852-3ef48c61b3db",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "starPlaces",
      x: 198,
      y: -56,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 10,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "big_star_place",
      parent: "1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2",
      data: ""
    },
    {
      id: "d77fcf89-6d18-4824-911c-a94d10e91da4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "stars",
      x: -198,
      y: -56,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -10,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "big_star",
      parent: "1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2",
      data: ""
    },
    {
      id: "a25953ea-0ce1-473e-90f6-1776337e9b55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "stars",
      x: 0,
      y: -67,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "big_star",
      parent: "1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2",
      data: ""
    },
    {
      id: "19e5ee6f-6fd7-4323-8e84-0402cd1f031d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "stars",
      x: 198,
      y: -56,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 10,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "big_star",
      parent: "1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2",
      data: ""
    },
    {
      id: "f4c22154-70cc-4c5a-b9b2-a75459e6c891",
      type: "Sprite",
      name: "playButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_green",
      parent: "6635b2ef-0304-4c20-bb80-a1e9f6eea59f",
      data: ""
    },
    {
      id: "013a20b6-2e6b-49b0-9c24-1a3582e68c3e",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: -260,
      y: 75,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "RemainingStackCards",
      localize: true,
      maxWidth: 360,
      maxHeight: 43,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 23,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#982513",
        stroke: "black",
        strokeThickness: 0,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "280699fb-d598-46e8-9ddd-c56b604573e7",
      data: ""
    },
    {
      id: "7021b05d-9b1c-4ff4-bd48-6e4ede2844a9",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: -260,
      y: 114,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "LevelCleared",
      localize: true,
      maxWidth: 360,
      maxHeight: 43,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 23,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#982513",
        stroke: "black",
        strokeThickness: 0,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "280699fb-d598-46e8-9ddd-c56b604573e7",
      data: ""
    },
    {
      id: "b5b7ad11-143d-4288-b27f-87778ceb1b7f",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: -260,
      y: 180,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "YouWon",
      localize: true,
      maxWidth: 327,
      maxHeight: 43,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 23,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#982513",
        stroke: "black",
        strokeThickness: 0,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "280699fb-d598-46e8-9ddd-c56b604573e7",
      data: ""
    },
    {
      id: "762eca06-0dbf-43bf-bea7-2b5c7d2ba216",
      type: "Text",
      name: "stackReward",
      nameSpace: "",
      className: "",
      x: 223,
      y: 75,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "12900",
      localize: false,
      maxWidth: 120,
      maxHeight: 45,
      maxFontSize: 29,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#8c261d",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "280699fb-d598-46e8-9ddd-c56b604573e7",
      data: ""
    },
    {
      id: "f5eeec02-4386-44fe-95fc-ee771d086455",
      type: "Text",
      name: "levelReward",
      nameSpace: "",
      className: "",
      x: 223,
      y: 114,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "2880",
      localize: false,
      maxWidth: 120,
      maxHeight: 45,
      maxFontSize: 29,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#8c261d",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "280699fb-d598-46e8-9ddd-c56b604573e7",
      data: ""
    },
    {
      id: "a9d4ee32-f2e4-40af-b62c-870cd52cc650",
      type: "Text",
      name: "totalReward",
      nameSpace: "",
      className: "",
      x: 201,
      y: 180,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "15780",
      localize: false,
      maxWidth: 141,
      maxHeight: 58,
      maxFontSize: 44,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#8c261d",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "280699fb-d598-46e8-9ddd-c56b604573e7",
      data: ""
    },
    {
      id: "af4fee69-ce20-404b-9124-711823229417",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 247,
      y: 115,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "coin_medium",
      parent: "280699fb-d598-46e8-9ddd-c56b604573e7",
      data: ""
    },
    {
      id: "271724c8-dcaa-4f9d-a834-1707ac4a2eb6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 247,
      y: 76,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "coin_medium",
      parent: "280699fb-d598-46e8-9ddd-c56b604573e7",
      data: ""
    },
    {
      id: "bec8f573-78c1-4175-b992-be8d149b75b1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 242,
      y: 183,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "coin_medium_popup",
      parent: "280699fb-d598-46e8-9ddd-c56b604573e7",
      data: ""
    },
    {
      id: "48169862-db2a-4458-8134-5c976489402b",
      type: "Text",
      name: "playText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Continue",
      localize: true,
      maxWidth: 226,
      maxHeight: 71,
      maxFontSize: 48,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#074829",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "f4c22154-70cc-4c5a-b9b2-a75459e6c891",
      data: ""
    }
  ]
} as const;

export class LevelCompletePopupLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  sideContainer: GameObject<PIXI.Container>;
  bg: GameObject<PIXI.Sprite>;
  headerBg: GameObject<PIXI.Sprite>;
  levelText: GameObject<PIXI.Text>;
  starsContainer: GameObject<PIXI.Container>;
  closeButton: GameObject<PIXI.Sprite>;
  character: GameObject<PIXI.Sprite>;
  playContainer: GameObject<PIXI.Sprite>;
  playButton: GameObject<PIXI.Sprite>;
  playText: GameObject<PIXI.Text>;
  stackReward: GameObject<PIXI.Text>;
  levelReward: GameObject<PIXI.Text>;
  totalReward: GameObject<PIXI.Text>;
  starPlaces: (GameObject<PIXI.Sprite>)[];
  stars: (GameObject<PIXI.Sprite>)[];
  bottomLeftDeco: PIXI.Sprite;
  bottomRightDeco: PIXI.Sprite;

  constructor() {
    populate(this, raw);
  }
}
